import React from 'react';
import Row from './Row';
const RowCenter = (props, ref) => React.createElement(Row, { ref: ref, xAxis: "center", yAxis: "center", ...props });
export default React.forwardRef(RowCenter);
